import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatBytes',
  standalone: false,
})
export class FormatBytesPipe implements PipeTransform {
  constructor(
    private decimalPipe: DecimalPipe,
    private translateService: TranslateService
  ) {}

  /**
   * Transform given bytes into human-readable form (i.e. to ...B, ...KB, ...MB etc).
   * If decimals is not passed, then the biggest possible postfix is chosen.
   *
   * @param bytes Amount of bytes
   * @param decimals Amount of decimals to round to (0=B, 1=KB, 2=MB etc). If
   * not passed, then the biggest possible decimal value is used.
   */
  transform(bytes: number, decimals?: number): string {
    if (bytes == 0) return '0 B';
    else if (bytes == null) return '-';

    const k = 1024;
    const dm = decimals ?? Math.floor(Math.log10(bytes) / 3);
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const power = Math.floor(Math.log(bytes) / Math.log(k));
    const unitAdjustedSize = parseFloat((bytes / Math.pow(k, power)).toFixed(dm));

    return this.translateService.instant('common.fileSize', {
      size: this.decimalPipe.transform(unitAdjustedSize, undefined, this.translateService.currentLang),
      unit: units[power],
    });
  }
}
